import { API_CONFIG } from './api';

// Mapping delle città per determinare quale nazione/modello utilizzare
export const CITY_COUNTRY_MAPPING: { [cityName: string]: keyof typeof API_CONFIG.COUNTRIES } = {
  // Città svizzere - Ticino (utilizzano il modello escorts_svizzera)
  'chiasso': 'SVIZZERA',
  'lugano': 'SVIZZERA',
  'bellinzona': 'SVIZZERA',
  'locarno': 'SVIZZERA',
  'mendrisio': 'SVIZZERA',
  'ascona': 'SVIZZERA',
  'biasca': 'SVIZZERA',
  'acquarossa': 'SVIZZERA',
  'airolo': 'SVIZZERA',
  'balerna': 'SVIZZERA',
  'bissone': 'SVIZZERA',
  'bodio': 'SVIZZERA',
  'brione sopra minusio': 'SVIZZERA',
  'cadenazzo': 'SVIZZERA',
  'castel san pietro': 'SVIZZERA',
  'cevio': 'SVIZZERA',
  'faido': 'SVIZZERA',
  'gambarogno': 'SVIZZERA',
  'giornico': 'SVIZZERA',
  'gordola': 'SVIZZERA',
  'magadino': 'SVIZZERA',
  'malvaglia': 'SVIZZERA',
  'massagno': 'SVIZZERA',
  'melano': 'SVIZZERA',
  'mesocco': 'SVIZZERA',
  'minusio': 'SVIZZERA',
  'muralto': 'SVIZZERA',
  'novazzano': 'SVIZZERA',
  'olivone': 'SVIZZERA',
  'origlio': 'SVIZZERA',
  'paradiso': 'SVIZZERA',
  'ponte capriasca': 'SVIZZERA',
  'pregassona': 'SVIZZERA',
  'rivera': 'SVIZZERA',
  'riva san vitale': 'SVIZZERA',
  'savosa': 'SVIZZERA',
  'stabio': 'SVIZZERA',
  'tenero-contra': 'SVIZZERA',
  'tesserete': 'SVIZZERA',
  'vacallo': 'SVIZZERA',
  'vezia': 'SVIZZERA',
  'viganello': 'SVIZZERA',
  
  // Altre città svizzere principali (per future espansioni)
  'zurigo': 'SVIZZERA',
  'ginevra': 'SVIZZERA',
  'basilea': 'SVIZZERA',
  'berna': 'SVIZZERA',
  'losanna': 'SVIZZERA',
  'winterthur': 'SVIZZERA',
  'lucerna': 'SVIZZERA',
  'san gallo': 'SVIZZERA',
  
  // Le città italiane non sono specificate qui, useranno il default (ITALIA)
};

/**
 * Determina quale paese/modello utilizzare basato sulla città
 * @param cityName Nome della città (case insensitive)
 * @returns Il codice del paese da utilizzare, default ITALIA
 */
export const getCountryByCity = (cityName: string): keyof typeof API_CONFIG.COUNTRIES => {
  if (!cityName) return 'ITALIA';
  
  const normalizedCity = cityName.toLowerCase().trim();
  const mappedCountry = CITY_COUNTRY_MAPPING[normalizedCity] || 'ITALIA';
  
  // Log per debugging solo se è mappata una città diversa dall'Italia
  if (mappedCountry !== 'ITALIA') {
    console.log(`🗺️ Città "${cityName}" mappata a paese: ${mappedCountry}`);
  }
  
  return mappedCountry;
};

/**
 * Verifica se una città è mappata per un paese specifico
 * @param cityName Nome della città
 * @param countryCode Codice del paese
 * @returns true se la città appartiene al paese specificato
 */
export const isCityInCountry = (cityName: string, countryCode: keyof typeof API_CONFIG.COUNTRIES): boolean => {
  const cityCountry = getCountryByCity(cityName);
  return cityCountry === countryCode;
};

/**
 * Ottiene tutte le città mappate per un paese specifico
 * @param countryCode Codice del paese
 * @returns Array di nomi delle città
 */
export const getCitiesForCountry = (countryCode: keyof typeof API_CONFIG.COUNTRIES): string[] => {
  return Object.entries(CITY_COUNTRY_MAPPING)
    .filter(([_, country]) => country === countryCode)
    .map(([city, _]) => city);
};